export default __webpack_public_path__ + "static/Retul+fit_Injury+Prevention_Web-ab9d513842888460259e16da38f7db61.jpg";